import type { HTMLAttributes, ReactNode } from "react";
import { classNames } from "../internal/classNames";
import { StatusGlyph } from "../internal/StatusGlyph";
import type { StatusGlyphName } from "../internal/StatusGlyph";
import "./StatusBadge.css";

export type StatusBadgeVariant =
  | "information"
  | "waiting"
  | "processing"
  | "verification"
  | "attention"
  | "success"
  | "danger"
  | "neutral";

export interface StatusBadgeProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: StatusBadgeVariant;
  children: ReactNode;
}

const glyphs: Record<StatusBadgeVariant, StatusGlyphName> = {
  information: "information",
  waiting: "clock",
  processing: "processing",
  verification: "search",
  attention: "attention",
  success: "check",
  danger: "close",
  neutral: "neutral",
};

export function StatusBadge({ variant = "neutral", className, children, ...props }: StatusBadgeProps) {
  return (
    <span {...props} className={classNames("cp-status-badge", `cp-status-badge--${variant}`, className)}>
      <StatusGlyph className="cp-status-badge__icon" name={glyphs[variant]} />
      <span>{children}</span>
    </span>
  );
}
